import Button from "@/common/components/Button"
import { RewardItemData } from "@/common/types/rewardItems"
import { ArrowBigRight } from "lucide-react"
import { Link } from "react-router-dom"

export class RewardItemsTransformer {
  static tableTransformer() {
    return (rewardsItems: RewardItemData[]) => {
      return rewardsItems.map((rewardItem) => {
        return {
          ...rewardItem,
          actions: (
            <Link to={`/tmais-reward-items/${rewardItem.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Establishment::Tmais::Products::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          )
        }
      })
    }
  }
}
